module.exports = __webpack_public_path__ + "static/avatar-3cd2092f0b6d6a437c731e171be68512.jpg";